__turbopack_context__.v({
  "CarouselHeroCard": "yV0waa_CarouselHeroCard",
});
